import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { gql } from '../../utils/gqlClient';
import { wrapQuery } from '../../utils/wrapQuery';
export { signup };
var signupMutation = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  mutation Signup(\n    $userCredentials: UserCredentials!\n    $userProfile: UserProfile!\n    $clientId: String!\n  ) {\n    signUpUser(userCredentials: $userCredentials, userProfile: $userProfile, clientId: $clientId) {\n      tokens {\n        idToken\n        accessToken\n        expires\n      }\n      encryptedEmail\n      encryptedCheggId\n    }\n  }\n"])));
function signup(_x, _x2, _x3) {
  return _signup.apply(this, arguments);
}
function _signup() {
  _signup = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(creds, profile, client) {
    var data;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return wrapQuery('signup', signupMutation, {
            userCredentials: creds,
            userProfile: profile,
            clientId: client
          });
        case 2:
          data = _context.sent;
          return _context.abrupt("return", data.signUpUser);
        case 4:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _signup.apply(this, arguments);
}